module.exports = __webpack_public_path__ + "img/72000.a3610e9c.jpg";